// extracted by mini-css-extract-plugin
export default {"bot_return_button":"styles_bot_return_button__Rib8m","return_icon":"styles_return_icon__MeSKv"};